/* eslint-disable */
import Cookies from 'js-cookie'

export function ParseJwt(token : string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    const payload = JSON.parse(jsonPayload);
   
    
    return payload
}

export function StoreCookie(key : string, value : string){

	const settings = process.env.NODE_ENV == 'development' ? {  /*sameSite: 'Strict'*/ } : {
		secure: true, 
		domain : process.env.VUE_APP_DOMAIN,
    	sameSite: "Strict",
	} as any;

	Cookies.set(key, value, settings)
}
